import { memo } from "react";
import { ButtonInputProps } from "../../../Interface/interface";
// import "./Button.scss";
import { Button } from "@mui/material";
import React from "react";

const ButtonComponent = memo(({ label, type = "button", style, className, startIcon, children, onClick, disable = false, buttonColor = "primary", dataTestid }: ButtonInputProps) => (
  <Button type={type} sx={{
    ...style,
    // Conditionally change background and text color for disabled state
    "&.Mui-disabled": {
      backgroundColor: "#B8B9DD      !important", // Change to the desired background color
      border: "1px solid #B8B9DD",
      color: "white", // Change to the desired text color
    },
  }} color={buttonColor} className={className} startIcon={startIcon} onClick={onClick} variant="contained" data-testid={dataTestid ?? "Update Profile"} // This should be applied to the button element

    disabled={Boolean(disable)}>{label} {children}
  </Button>
));

ButtonComponent.displayName = "ButtonComponent";

export default ButtonComponent;
